import { createRolesHooks } from '@gasbi/shared/common/features/roles';

import { useGetCachedRoleByIdSelector as useGetCachedOrgRoleByIdSelector } from '../organizations/organizationsApi';
import { organizationRolesApi } from './organizationRolesApi';
import { isRootRole } from './utils';

// Distribution Admin has the head office (PO, 2026-10-26: «Адміністрація»), so the head office side of the hooks
// is the organization roles too.
export const {
  useGetSystemRolesQuery,
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useSaveRoleMutation,
  useAssignRoleMutation,
  useSuspendRoleMutation,
  useGetCachedRoleByIdSelector,
} = createRolesHooks(
  organizationRolesApi,
  organizationRolesApi,
  useGetCachedOrgRoleByIdSelector,
  useGetCachedOrgRoleByIdSelector,
  isRootRole,
);
